import { render, staticRenderFns } from "./process-urgentorder.vue?vue&type=template&id=83c250a2&"
import script from "./process-urgentorder.vue?vue&type=script&lang=ts&"
export * from "./process-urgentorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports